import {
  ProductAttributeInfo,
  ProductAttributeType,
  ProductBasePrice,
  ProductImageDto,
  ProductNetFillQuantity,
  SalesConditionInfo,
  SalesConditionType
} from '@eurogast/hub-client-typescript';

export abstract class ProductDeserializer {
  public static parseUnit(unitString: string): UnitDefinition {
    const parts = unitString.split('::');
    if (parts.length !== 6) {
      throw Error(`Invalid unit format: ${unitString}`);
    }
    return {
      abbreviation: parts[0],
      name: parts[1],
      ratio: Number.parseFloat(parts[2]),
      isDefault: parts[3] === 'true',
      isStorageUnit: parts[4] === 'true',
      isVisible: parts[5] === 'true'
    };
  }

  public static parseImage(source: string): ProductImageDto {
    const parts = source.split('::');
    if (parts.length !== 4) {
      throw Error(`Invalid image format: ${source}`);
    }
    return {
      thumbnailPath: parts[0],
      mediumPath: parts[1],
      bigPath: parts[2],
      is3d: parts[3] === 'true'
    };
  }

  public static parseSalesCondition(source: string): SalesConditionInfo {
    const parts = source.split('::');
    if (parts.length !== 2) {
      throw Error(`Invalid sales condition format: ${source}`);
    }
    return {
      key: SalesConditionType[parts[0]],
      displayName: parts[1]
    };
  }

  public static parseAttribute(source: string): ProductAttributeInfo {
    const parts = source.split('::');
    if (parts.length !== 3) {
      throw Error(`Invalid product attribute format: ${source}`);
    }
    return {
      key: ProductAttributeType[parts[0]],
      displayName: parts[1],
      extension: parts[2] === 'null' ? null : parts[2]
    };
  }

  public static parseNetFill(source: string): ProductNetFillQuantity {
    const parts = source.split('::');
    if (parts.length !== 2) {
      throw Error(`Invalid product netFillQuantity format: ${source}`);
    }
    return {
      quantity: Number.parseFloat(parts[0]),
      unit: parts[1]
    };
  }

  public static parseBasePrice(source: string): ProductBasePrice {
    const parts = source.split('::');
    if (parts.length !== 4) {
      throw Error(`Invalid product basePrice format: ${source}`);
    }
    return {
      quantity: Number.parseFloat(parts[0]),
      unit: parts[1],
      refQuantity: Number.parseFloat(parts[2]),
      refUnit: parts[3]
    };
  }
}

export interface UnitDefinition {
  abbreviation: string;
  name: string;
  ratio: number;
  isDefault?: boolean;
  isStorageUnit?: boolean;
  isVisible?: boolean;
}
